import {normalizeNumberFromUrl} from './normalizeNumberFromUrl'

// Получить ID из URL slug вида {slug}-{id} или просто {id}.
export function extractIdFromUrlSlug(slugWithId: string | null | undefined): number | null {
    if (typeof slugWithId !== 'string' || slugWithId.trim().length === 0) {
        return null
    }
    const matches = slugWithId.match(/(?:^|-)(\d+)$/)
    if (!matches) {
        return null
    }
    return normalizeNumberFromUrl(matches[1])
}
